import React, { useEffect } from 'react';
import { Field } from 'formik';
import { useFormikContext } from 'formik';

import { InputUI, AutoCompleteSelectUI, FormErrorUI, FormLabelUI, DatePickerUI, SelectUI } from '../Interface';
import useParam from '../../context/ParamContext';
import { MaterialPolicyLabels } from '../../config/service';
import { getProjectOrderNumberName } from '../../utils/getProjectOrderNumberName';

const ServiceFields = ({ viewField, autocompleteData, autocompleteOptions }) => {
  const { values, validateField, setFieldValue, errors } = useFormikContext();
  const { getParam, params } = useParam();

  useEffect(() => {
    getParam();
  }, []);

  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="md:col-span-1 col-span-4">
        <Field
          type="text"
          name="workingNumber"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Munkaszám" />}
          helperText={<FormErrorUI message={errors.workingNumber} />}
          variant="standard"
          disabled={true}
          InputLabelProps={{ shrink: values.workingNumber && values.workingNumber !== '' }}
        />
      </div>
      {/*<div className="md:col-span-1 col-span-4">
        <Field
          type="autocomplete"
          name="serviceOperationTaskListId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Művelet" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.serviceOperationTaskListId} />}
          onChange={(_e, newVal) => {
            setFieldValue('serviceOperationTaskListId', newVal?.value ?? null).then(() => {
              validateField('serviceOperationTaskListId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.serviceOperationTaskListId !== '' }}
          selectedValue={values.serviceOperationTaskListId}
          selectedLabelValue={selectedValues?.serviceOperationTask?.name}
          dataset={autocompleteOptions?.serviceOperationTask}
        />
      </div>*/}
      <div className="md:col-span-1 col-span-4">
        <Field
          type="autocomplete"
          name="projectId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Projekt" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.projectId} />}
          onChange={(_e, newVal) => {
            const findedProject = autocompleteData?.project.find((item) => item.projectId === newVal?.value);
            if (findedProject) {
              setFieldValue('projectOrderNumber', findedProject.orderNumber || '');
            } else {
              setFieldValue('projectOrderNumber', '');
            }

            setFieldValue('projectId', newVal?.value ?? null).then(() => {
              validateField('projectId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.projectId !== null }}
          selectedValue={values.projectId}
          selectedLabelValue={autocompleteData?.project?.find((p) => p.value === values.projectId)?.label}
          dataset={autocompleteOptions?.project}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="projectOrderNumber"
          component={InputUI}
          fullWidth
          label={<FormLabelUI text={getProjectOrderNumberName(params)} />}
          variant="standard"
          helperText={<FormErrorUI message={errors.projectOrderNumber} />}
          disabled={true}
          InputLabelProps={{ shrink: values.projectOrderNumber !== '' }}
          value={values.projectOrderNumber}
        />
      </div>
      <div className="md:col-span-1 col-span-4">
        <Field
          type="autocomplete"
          name="serviceTaskTypeId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Szerviz típus" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.serviceTaskTypeId} />}
          onChange={(_e, newVal) => {
            setFieldValue('serviceTaskTypeId', newVal?.value ?? null).then(() => {
              validateField('serviceTaskTypeId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.serviceTaskTypeId !== null }}
          selectedValue={values.serviceTaskTypeId}
          selectedLabelValue={
            autocompleteData?.serviceTaskType?.find((stt) => stt.value === values.serviceTaskTypeId)?.label
          }
          dataset={autocompleteOptions?.serviceTaskType}
        />
      </div>

      <div className="md:col-span-1 col-span-4">
        <Field
          type="autocomplete"
          name="costCenterId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Költséghely" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.costCenterId} />}
          onChange={(_e, newVal) => {
            setFieldValue('costCenterId', newVal?.value ?? null).then(() => {
              validateField('costCenterId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.costCenterId !== null }}
          selectedValue={values.costCenterId}
          selectedLabelValue={autocompleteData?.costCenter?.find((cc) => cc.value === values.costCenterId)?.label}
          dataset={autocompleteOptions?.costCenter}
        />
      </div>

      <div className="md:col-span-1 col-span-4">
        <Field
          type="autocomplete"
          name="companyId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Cég" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.companyId} />}
          onChange={(_e, newVal) => {
            setFieldValue('companyId', newVal?.value ?? null).then(() => {
              validateField('companyId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.companyId !== null }}
          selectedValue={values.companyId}
          selectedLabelValue={autocompleteOptions?.company.find((c) => c.value === values.companyId)?.label}
          dataset={autocompleteOptions?.company}
        />
      </div>

      <div className="md:col-span-1 col-span-4">
        <Field
          type="autocomplete"
          name="serviceStatusId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Státusz" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.serviceStatusId} />}
          onChange={(_e, newVal) => {
            setFieldValue('serviceStatusId', newVal?.value ?? null).then(() => {
              validateField('serviceStatusId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.serviceStatusId !== null }}
          selectedValue={values.serviceStatusId}
          selectedLabelValue={
            autocompleteOptions.serviceStatus?.find((ss) => ss.value === values.serviceStatusId)?.label
          }
          dataset={autocompleteOptions?.serviceStatus}
        />
      </div>
      <div className="md:col-span-1 col-span-4">
        <Field
          type="autocomplete"
          name="priorityId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Prioritás" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.priorityId} />}
          onChange={(_e, newVal) => {
            setFieldValue('priorityId', newVal?.value ?? null).then(() => {
              validateField('priorityId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.priorityId !== null }}
          selectedValue={values.priorityId}
          selectedLabelValue={autocompleteOptions?.priority.find((p) => p.value === values.priorityId)?.label}
          dataset={autocompleteOptions?.priority}
        />
      </div>

      <div className="md:col-span-1 col-span-4">
        <Field
          type="autocomplete"
          name="userId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Tulajdonos" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.userId} />}
          onChange={(_e, newVal) => {
            setFieldValue('userId', newVal?.value ?? null).then(() => {
              validateField('userId');
            });
          }}
          disabled={true}
          InputLabelProps={{ shrink: values.userId !== null }}
          selectedValue={values.userId}
          selectedLabelValue={autocompleteOptions?.user?.find((u) => u.value === values.userId)?.label}
          dataset={autocompleteOptions?.user}
        />
      </div>

      <div className="md:col-span-1 col-span-4">
        <Field
          name="materialPolicy"
          component={SelectUI}
          fullWidth
          option={MaterialPolicyLabels}
          value={values.materialPolicy ?? ''}
          variant="standard"
          onChange={(e) => {
            const value = e.target.value;
            setFieldValue('materialPolicy', value ?? null).then(() => {
              validateField('materialPolicy');
            });
          }}
          label={<FormLabelUI text="Anyagkezelés" />}
          helperText={<FormErrorUI message={errors.materialPolicy} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.materialPolicy !== '' }}
        />
      </div>

      <div className="md:col-span-1 col-span-4">
        <Field
          type="date"
          name="startDate"
          component={DatePickerUI}
          value={values.startDate}
          fullWidth
          label={<FormLabelUI text="Kezdés dátuma" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.startDate} />}
          onChange={(date) => {
            setFieldValue('startDate', date).then(() => {
              validateField('startDate');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.startDate) }}
        />
      </div>

      <div className="md:col-span-1 col-span-4">
        <Field
          type="date"
          name="endDate"
          component={DatePickerUI}
          value={values.endDate}
          fullWidth
          label={<FormLabelUI text="Befejezés dátuma" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.endDate} />}
          onChange={(date) => {
            setFieldValue('endDate', date).then(() => {
              validateField('endDate');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.endDate) }}
        />
      </div>

      <div className="md:col-span-1 col-span-4">
        <Field
          type="date"
          name="dueDate"
          component={DatePickerUI}
          value={values.dueDate}
          fullWidth
          label={<FormLabelUI text="Határidő" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.dueDate} />}
          onChange={(date) => {
            setFieldValue('dueDate', date).then(() => {
              validateField('dueDate');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.dueDate) }}
        />
      </div>

      <div className="md:col-span-1 col-span-4">
        <Field
          type="text"
          name="reference"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Referencia" />}
          helperText={<FormErrorUI message={errors.reference} />}
          variant="standard"
          disabled={viewField}
          InputLabelProps={{ shrink: values.reference && values.reference !== '' }}
        />
      </div>
    </div>
  );
};

export default ServiceFields;
